import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "form-group certification-selector" };
const _hoisted_2 = { class: "col mx-3" };
const _hoisted_3 = ["id", "value", "disabled"];
const _hoisted_4 = ["for"];
const _hoisted_5 = { class: "row" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = { class: "col mx-3" };
const _hoisted_8 = ["id", "value", "disabled"];
const _hoisted_9 = ["for"];
const _hoisted_10 = { class: "row flex-nowrap" };
const _hoisted_11 = ["disabled"];
const _hoisted_12 = { class: "col mx-3" };
const _hoisted_13 = ["id", "value", "disabled"];
const _hoisted_14 = ["for"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_STROKE_CERTIFICATIONS')), 1),
        _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.strokeCertifications, (cert) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "row flex-nowrap",
                    key: cert.id
                }, [
                    _withDirectives(_createElementVNode("input", {
                        class: "col-auto",
                        id: cert.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.selectedStrokeId) = $event)),
                        type: "radio",
                        value: cert.id,
                        cert: "stroke",
                        disabled: $props.viewMode
                    }, null, 8, _hoisted_3), [
                        [_vModelRadio, $setup.selectedStrokeId]
                    ]),
                    _createElementVNode("label", {
                        class: "col col-form-label",
                        for: cert.id
                    }, "[" + _toDisplayString(cert.slug.toUpperCase()) + "] " + _toDisplayString(cert.label), 9, _hoisted_4)
                ]));
            }), 128)),
            _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                    class: "col-auto",
                    id: "stroke-none",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.selectedStrokeId) = $event)),
                    type: "radio",
                    value: null,
                    disabled: $props.viewMode
                }, null, 8, _hoisted_6), [
                    [_vModelRadio, $setup.selectedStrokeId]
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                    class: "col col-form-label",
                    for: "stroke-none"
                }, "None", -1))
            ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_CARDIAC_CERTIFICATIONS')), 1),
        _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardioCertifications, (cert) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "row flex-nowrap",
                    key: cert.id
                }, [
                    _withDirectives(_createElementVNode("input", {
                        class: "col-auto",
                        id: cert.id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.selectedCardioId) = $event)),
                        type: "radio",
                        value: cert.id,
                        disabled: $props.viewMode
                    }, null, 8, _hoisted_8), [
                        [_vModelRadio, $setup.selectedCardioId]
                    ]),
                    _createElementVNode("label", {
                        class: "col col-form-label",
                        for: cert.id
                    }, "[" + _toDisplayString(cert.slug.toUpperCase()) + "] " + _toDisplayString(cert.label), 9, _hoisted_9)
                ]));
            }), 128)),
            _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                    class: "col-auto",
                    id: "cardio-none",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.selectedCardioId) = $event)),
                    type: "radio",
                    value: null,
                    disabled: $props.viewMode
                }, null, 8, _hoisted_11), [
                    [_vModelRadio, $setup.selectedCardioId]
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                    class: "col col-form-label",
                    for: "cardio-none"
                }, "None", -1))
            ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_CAPABILITIES')), 1),
        _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fetchedCapabilities, (capability) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "row flex-nowrap",
                    key: capability.id
                }, [
                    _withDirectives(_createElementVNode("input", {
                        class: "col-auto",
                        id: capability.id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.selectedCapabilityIds) = $event)),
                        type: "checkbox",
                        value: capability.id,
                        disabled: $props.viewMode || $setup.unselectableCapabilitySlugs.includes(capability.slug)
                    }, null, 8, _hoisted_13), [
                        [_vModelCheckbox, $setup.selectedCapabilityIds]
                    ]),
                    _createElementVNode("label", {
                        class: "col col-form-label",
                        for: capability.id
                    }, "[" + _toDisplayString(capability.slug.toUpperCase()) + "] " + _toDisplayString(capability.label), 9, _hoisted_14)
                ]));
            }), 128))
        ])
    ]));
}
